var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('b-icon-check-circle-fill',{style:(_vm.iconSize),attrs:{"variant":"success"}}):_c('b-icon-x-circle-fill',{style:(_vm.iconSize),attrs:{"variant":"danger"}})}
var staticRenderFns = []

export { render, staticRenderFns }